<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-shop"></i> 门店详情
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 门店头部信息 -->
      <div class="shop-header">
        <div class="shop-logo">
          <img :src="shopInfo.logo || defaultLogo" alt="门店Logo" @error="handleLogoError" />
        </div>
        <div class="shop-title">
          <h2>{{ shopInfo.name }}</h2>
          <div class="shop-tags">
            <el-tag :type="getStatusType(shopInfo.is_auth)" size="small">
              {{ getStatusText(shopInfo.is_auth) }}
            </el-tag>
            <el-tag v-if="shopInfo.grade_name" type="primary" size="small" effect="plain">
              {{ shopInfo.grade_name }}
            </el-tag>
            <el-tag v-if="shopInfo.category_name" type="info" size="small" effect="plain">
              {{ shopInfo.category_name }}
            </el-tag>
          </div>
        </div>
        <div class="shop-actions">
          <el-button type="primary" size="small" @click="goEdit" icon="el-icon-edit">编辑</el-button>
          <el-button size="small" @click="goBack" icon="el-icon-back">返回</el-button>
        </div>
      </div>

      <!-- 信息卡片区域 -->
      <el-row :gutter="20">
        <!-- 基本信息 -->
        <el-col :xs="24" :sm="24" :md="12">
          <div class="info-card">
            <div class="card-header">
              <i class="el-icon-info"></i>
              <span>基本信息</span>
            </div>
            <div class="card-content">
              <div class="info-row">
                <span class="label">门店名称：</span>
                <span class="value">{{ shopInfo.name || '-' }}</span>
              </div>
              <div class="info-row">
                <span class="label">门店编码：</span>
                <span class="value">{{ shopInfo.sn || '-' }}</span>
              </div>
              <div class="info-row">
                <span class="label">门店类别：</span>
                <span class="value">{{ shopInfo.grade_name || '-' }}</span>
              </div>
              <div class="info-row">
                <span class="label">门店分类：</span>
                <span class="value">{{ shopInfo.category_name || '-' }}</span>
              </div>
              <div class="info-row">
                <span class="label">营业执照负责人：</span>
                <span class="value">{{ shopInfo.artiperson || '-' }}</span>
              </div>
              <div class="info-row">
                <span class="label">入驻时间：</span>
                <span class="value">{{ shopInfo.contract_start_time || '-' }}</span>
              </div>
              <div class="info-row">
                <span class="label">门店官网：</span>
                <span class="value">
                  <a v-if="shopInfo.url" :href="shopInfo.url" target="_blank">{{ shopInfo.url }}</a>
                  <span v-else>-</span>
                </span>
              </div>
            </div>
          </div>
        </el-col>

        <!-- 联系方式 -->
        <el-col :xs="24" :sm="24" :md="12">
          <div class="info-card">
            <div class="card-header">
              <i class="el-icon-phone"></i>
              <span>联系方式</span>
            </div>
            <div class="card-content">
              <div class="info-row">
                <span class="label">联系人：</span>
                <span class="value">{{ shopInfo.cont_name || '-' }}</span>
              </div>
              <div class="info-row">
                <span class="label">联系电话：</span>
                <span class="value">{{ shopInfo.telephone || '-' }}</span>
              </div>
              <div class="info-row">
                <span class="label">联系手机：</span>
                <span class="value">{{ shopInfo.mobile || '-' }}</span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="20" style="margin-top: 20px">
        <!-- 地址信息 -->
        <el-col :xs="24" :sm="24" :md="12">
          <div class="info-card">
            <div class="card-header">
              <i class="el-icon-location"></i>
              <span>地址信息</span>
            </div>
            <div class="card-content">
              <div class="info-row">
                <span class="label">所属区域：</span>
                <span class="value">{{ shopInfo.province_name || '' }} {{ shopInfo.city_name || '' }} {{ shopInfo.district_name || '' }}</span>
              </div>
              <div class="info-row">
                <span class="label">详细地址：</span>
                <span class="value">{{ shopInfo.address || '-' }}</span>
              </div>
            </div>
          </div>
        </el-col>

        <!-- 地图位置 -->
        <el-col :xs="24" :sm="24" :md="12">
          <div class="info-card">
            <div class="card-header">
              <i class="el-icon-map-location"></i>
              <span>地图位置</span>
            </div>
            <div class="card-content">
              <div class="info-row" v-if="shopInfo.lng && shopInfo.lat">
                <span class="label">坐标：</span>
                <span class="value">经度 {{ shopInfo.lng }}，纬度 {{ shopInfo.lat }}</span>
              </div>
              <div class="info-row" v-else>
                <span class="label">坐标：</span>
                <span class="value">未设置</span>
              </div>
              <div class="map-container" v-if="shopInfo.lng && shopInfo.lat">
                <div id="shop-map" class="shop-map"></div>
              </div>
              <div v-else class="map-placeholder">
                <i class="el-icon-location-outline"></i>
                <span>暂无位置信息</span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <!-- 店铺详情 -->
      <div class="info-card" style="margin-top: 20px">
        <div class="card-header">
          <i class="el-icon-document"></i>
          <span>店铺详情</span>
        </div>
        <div class="card-content">
          <div class="info-row">
            <span class="label">店铺简介：</span>
            <span class="value">{{ shopInfo.service || '-' }}</span>
          </div>
          <div class="info-row" v-if="shopInfo.description">
            <span class="label">详细介绍：</span>
            <div class="value rich-content" v-html="shopInfo.description"></div>
          </div>
        </div>
      </div>

      <!-- 店铺图片 -->
      <div class="info-card" style="margin-top: 20px" v-if="fileList.length > 0">
        <div class="card-header">
          <i class="el-icon-picture"></i>
          <span>店铺图片</span>
        </div>
        <div class="card-content">
          <div class="image-list">
            <div 
              v-for="(img, index) in fileList" 
              :key="index" 
              class="image-item"
              @click="previewImage(index)"
            >
              <el-image :src="img.url" fit="cover" :preview-src-list="imageList" :initial-index="index">
                <div slot="placeholder" class="image-placeholder">
                  <i class="el-icon-loading"></i>
                </div>
                <div slot="error" class="image-error">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import moment from 'moment'

export default {
  name: "shopInfo",
  data() {
    return {
      defaultLogo: require('@/assets/logo.png'),
      shopInfo: {
        id: '',
        name: '',
        sn: '',
        logo: '',
        grade_id: '',
        grade_name: '',
        cat_id: '',
        category_name: '',
        artiperson: '',
        contract_start_time: '',
        url: '',
        cont_name: '',
        telephone: '',
        mobile: '',
        province_id: '',
        province_name: '',
        city_id: '',
        city_name: '',
        district_id: '',
        district_name: '',
        address: '',
        service: '',
        description: '',
        is_auth: 0,
        lng: '',
        lat: ''
      },
      fileList: [],
      imageList: [],
      map: null
    }
  },
  computed: {
    getStatusType() {
      return (status) => {
        if (status == 1) return 'success'
        if (status == 2) return 'danger'
        return 'warning'
      }
    },
    getStatusText() {
      return (status) => {
        if (status == 1) return '已审核'
        if (status == 2) return '驳回'
        return '待审核'
      }
    }
  },
  mounted() {
    const id = this.$route.query.id
    if (id && !isNaN(id) && id > 0) {
      this.getShopInfo(id)
    } else {
      this.$message.error('门店ID不存在')
      this.goBack()
    }
  },
  beforeDestroy() {
    if (this.map) {
      this.map.destroy()
      this.map = null
    }
  },
  methods: {
    // 获取门店信息
    getShopInfo(id) {
      const param = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
        id: id
      }
      this.$axios.shopOne(param).then(res => {
        if (res.code == 200) {
          const data = res.data
          this.shopInfo = {
            id: data.id,
            name: data.name,
            sn: data.sn,
            logo: data.logo,
            grade_id: data.grade_id,
            grade_name: data.grade_name,
            cat_id: data.cat_id,
            category_name: data.category_name,
            artiperson: data.artiperson,
            contract_start_time: data.contract_start_time ? moment(data.contract_start_time).format('YYYY-MM-DD') : '',
            url: data.url,
            cont_name: data.cont_name,
            telephone: data.telephone,
            mobile: data.mobile,
            province_id: data.province_id,
            province_name: data.province?.region_name || data.province_name,
            city_id: data.city_id,
            city_name: data.city?.region_name || data.city_name,
            district_id: data.district_id,
            district_name: data.district?.region_name || data.district_name,
            address: data.address,
            service: data.service,
            description: data.description,
            is_auth: data.is_auth,
            lng: data.lng,
            lat: data.lat
          }
          
          // 加载图片列表
          if (data.pictures && data.pictures.length) {
            this.fileList = data.pictures.map(pic => ({
              name: pic.img_desc || '店铺图片',
              url: pic.img_url
            }))
            this.imageList = this.fileList.map(item => item.url)
          }
          
          // 如果有坐标，初始化地图
          if (this.shopInfo.lng && this.shopInfo.lat) {
            this.$nextTick(() => {
              this.initMap()
            })
          }
        } else {
          this.$message.error(res.msg || '获取门店信息失败')
        }
      }).catch(error => {
        console.error('获取门店信息失败:', error)
        this.$message.error('获取门店信息失败')
      })
    },
    
    // 初始化地图
    async initMap() {
      if (!this.shopInfo.lng || !this.shopInfo.lat) return
      
      const container = document.getElementById('shop-map')
      if (!container) return
      
      try {
        const AMap = await AMapLoader.load({
          key: 'a50f6a3b0f5058fa09bfbf6ad5acb4e3',
          version: '2.0',
          plugins: ['AMap.Scale', 'AMap.ToolBar']
        })
        
        this.map = new AMap.Map('shop-map', {
          zoom: 15,
          center: [parseFloat(this.shopInfo.lng), parseFloat(this.shopInfo.lat)],
          resizeEnable: true
        })
        
        // 添加标记
        const marker = new AMap.Marker({
          position: [parseFloat(this.shopInfo.lng), parseFloat(this.shopInfo.lat)],
          map: this.map,
          title: this.shopInfo.name
        })
        
        // 添加信息窗体
        const infoWindow = new AMap.InfoWindow({
          content: `<div style="padding: 5px 10px;"><strong>${this.shopInfo.name}</strong><br/>${this.shopInfo.address || ''}</div>`,
          offset: new AMap.Pixel(0, -30)
        })
        
        marker.on('click', () => {
          infoWindow.open(this.map, marker.getPosition())
        })
        
      } catch (error) {
        console.error('地图加载失败:', error)
      }
    },
    
    // 预览图片
    previewImage(index) {
      this.$previewImage(this.imageList, index)
    },
    
    // 处理Logo加载错误
    handleLogoError(e) {
      e.target.src = this.defaultLogo
    },
    
    // 编辑
    goEdit() {
      this.$router.push({
        path: '/shopForm',
        query: { id: this.shopInfo.id }
      })
    },
    
    // 返回
    goBack() {
      this.$router.push('/shopList')
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb { font-size: 14px; i { margin-right: 4px; } }
}

.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover { box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08); }
  .el-card__body { padding: 20px 24px; }
}

// 门店头部
.shop-header {
  display: flex;
  align-items: center;
  gap: 20px;
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #f0f0f0;
  
  .shop-logo {
    width: 80px;
    height: 80px;
    border-radius: 12px;
    overflow: hidden;
    background: #f8f9fc;
    border: 1px solid #e4e7ed;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  
  .shop-title {
    flex: 1;
    
    h2 {
      font-size: 20px;
      font-weight: 600;
      color: #1f2d3d;
      margin: 0 0 8px 0;
    }
    
    .shop-tags {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
    }
  }
  
  .shop-actions {
    display: flex;
    gap: 12px;
    
    .el-button {
      border-radius: 20px;
    }
    .el-button--primary { background: #1677ff; border-color: #1677ff; &:hover { background: #4096ff; border-color: #4096ff; } }
  }
}

// 信息卡片
.info-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e4e7ed;
  overflow: hidden;
  
  .card-header {
    padding: 14px 16px;
    background: #f8f9fc;
    border-bottom: 1px solid #e4e7ed;
    display: flex;
    align-items: center;
    gap: 8px;
    
    i {
      font-size: 16px;
      color: #1677ff;
    }
    
    span {
      font-size: 15px;
      font-weight: 600;
      color: #1f2d3d;
    }
  }
  
  .card-content {
    padding: 16px;
  }
}

.info-row {
  display: flex;
  margin-bottom: 12px;
  line-height: 1.5;
  
  &:last-child { margin-bottom: 0; }
  
  .label {
    width: 100px;
    flex-shrink: 0;
    color: #8c8f98;
    font-size: 13px;
  }
  
  .value {
    flex: 1;
    color: #1f2d3d;
    font-size: 13px;
    word-break: break-all;
    
    a {
      color: #1677ff;
      text-decoration: none;
      &:hover { text-decoration: underline; }
    }
  }
}

// 地图样式
.map-container {
  margin-top: 12px;
  
  .shop-map {
    width: 100%;
    height: 200px;
    border-radius: 8px;
    overflow: hidden;
  }
}

.map-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background: #f8f9fc;
  border-radius: 8px;
  color: #c0c4cc;
  
  i { font-size: 48px; margin-bottom: 12px; }
  span { font-size: 13px; }
}

// 图片列表
.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  
  .image-item {
    width: 100px;
    height: 100px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    border: 1px solid #e4e7ed;
    transition: all 0.3s;
    
    &:hover {
      transform: scale(1.02);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
    
    ::v-deep .el-image {
      width: 100%;
      height: 100%;
    }
    
    .image-placeholder, .image-error {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      background: #f8f9fc;
      color: #c0c4cc;
      font-size: 24px;
    }
  }
}

.rich-content {
  ::v-deep img { max-width: 100%; }
  ::v-deep p { margin: 0 0 8px; }
}

// 响应式
@media (max-width: 768px) {
  .shop-header { flex-wrap: wrap; text-align: center; justify-content: center; .shop-actions { margin-top: 12px; } }
  .info-row { flex-direction: column; .label { width: auto; margin-bottom: 4px; } }
}
</style>